export const iconsType = {
    "0": "",
    "1": "checked",
    "2": "fiber",
    "3": "tv",
    "4": "mobile",
    "5": "gift",
    "6": "tvMultiPlay"
}

export const infrastructure = {
    "0": "FB",
    "1": "BF",
    "2": "BC",
}

export const salePackageType = {
    "0": "tv",
    "1": "app",
    "2": "cellular",
    "3": "internet",
    "4": "triple",
}